export const AzureADApplicationsTooltip = () => (
  <>
    AzureAD applications from Bayer tenant which can access Data Pond using
    their Service Principal token.
  </>
);
